import React from "react";
import { useNetlifySDK } from "../use_netlify_sdk.js";

export type ExtensionSettingsHeaderProps = {
  subheader?:
    | React.ReactNode
    | ((options: { name: string }) => React.JSX.Element)
    | undefined;
};

export const ExtensionSettingsHeader = ({
  subheader,
}: ExtensionSettingsHeaderProps) => {
  const sdk = useNetlifySDK();

  return (
    <header>
      <h2>{sdk.extension.name}</h2>
      {subheader === undefined && (
        <p>Easily connect {sdk.extension.name} to your Netlify account.</p>
      )}
      {typeof subheader === "function" &&
        subheader({ name: sdk.extension.name })}
      {subheader !== undefined && typeof subheader !== "function" && subheader}
    </header>
  );
};
